import { TextFieldWidget } from '@tableau/widgets';
import React = require('react');
import { Messages } from '~src/codegen/Localize';
import { characterCounter } from '~src/commonInfra/utils/CharacterCounter';

import { editGroupSetDialogFieldStyles, editGroupSetDialogLabelStyles, editGroupSetNameFieldStyles } from '../styles/EditGroupSetDialogStyles';
import { EditGroupSetDialogLabel } from './EditGroupSetDialogLabel';

export interface EditGroupSetNameFieldProps {
  readonly name: string;
  readonly groupSetNameError: string;
  readonly setName: (name: string) => void;
  readonly setGroupSetNameError: (errorMsg: string) => void;
}

export const CHARACTER_LIMIT = 255;

export function EditGroupSetNameField(props: EditGroupSetNameFieldProps): JSX.Element  {
    const setName = (name: string) => {
      const isValid = name.length <= CHARACTER_LIMIT ? true : false;
      const groupSetNameErrorMsg = isValid ? undefined : characterCounter({ value: name, maximum: CHARACTER_LIMIT });
      props.setName(name);
      props.setGroupSetNameError(groupSetNameErrorMsg);
    };

    return (
      <div style={editGroupSetDialogFieldStyles}>
        <EditGroupSetDialogLabel message={Messages.groupSetName()} style={editGroupSetDialogLabelStyles} />
        <TextFieldWidget
          label={''}
          testId='edit-group-name-field'
          onChange={e => setName(e.target.value)}
          onClear={() => setName('')}
          value={props.name}
          message={props.groupSetNameError ? props.groupSetNameError : undefined}
          valid={!props.groupSetNameError ? undefined : false }
          style={editGroupSetNameFieldStyles}
        />
      </div>
    );
}